<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a [routerLink]="['/home']">Home</a></li>
      <li class="breadcrumb-item"><a [routerLink]="['/smart-irrigation/regions']">Regions</a></li>
      <li class="breadcrumb-item"><a [routerLink]="parkId ? ['/smart-irrigation/parks', parkId] : ['/smart-irrigation/parks']">{{ parkName || 'Parks' }}</a></li>
      <li class="breadcrumb-item active">
        <div class="btn-group form-group-sm" dropdown>
          <a dropdownToggle class="link" style="cursor:pointer">
            {{ siteName || 'Site Dashboard' }}
            <i class="fa fa-sort-asc"></i>
          </a>
          <ul *dropdownMenu class="dropdown-menu" role="menu">
            <li role="menuitem" *ngFor="let n of allNodes">
              <a class="dropdown-item" [class.fw-bold]="n.id === nodeId" (click)="navigateToSite(n.id)">{{ n.name }}</a>
            </li>
          </ul>
        </div>
      </li>
    </ol>
  </div>
  <div class="col-lg-2 d-flex align-items-center justify-content-end gap-2" *ngIf="lastUpdated">
    <small class="text-muted" *ngIf="lastUpdated">{{ lastUpdated | date:'d MMM yyyy HH:mm' }}</small>
    <button class="btn btn-outline-white btn-sm" (click)="load()" [disabled]="loading" title="Refresh">
      <i class="fa fa-sync" [class.fa-spin]="loading"></i>
    </button>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight pt-3">

  <div class="alert alert-info" *ngIf="loading">
    <i class="fa fa-spinner fa-spin me-2"></i> Loading site data&hellip;
  </div>

  <div class="alert alert-warning" *ngIf="!loading && !controller">
    Controller not found. <a [routerLink]="['/smart-irrigation/regions']" class="alert-link">Go back</a>
  </div>

  <ng-container *ngIf="!loading && controller">
    <div class="sd-status-bar"
         [ngClass]="redCount > 0 ? 'sd-status-bar--alert' : amberCount > 0 ? 'sd-status-bar--warning' : 'sd-status-bar--normal'">
      <span class="sd-status-bar__text">
        <ng-container *ngIf="redCount > 0">&#9888; Alert &mdash; {{ redCount }} parameter(s) require investigation</ng-container>
        <ng-container *ngIf="redCount === 0 && amberCount > 0">&#9651; Warning &mdash; {{ amberCount }} parameter(s) to watch</ng-container>
        <ng-container *ngIf="redCount === 0 && amberCount === 0">&#10003; All parameters within normal range</ng-container>
      </span>
      <span class="sd-status-bar__counts">
        <span class="sd-dot sd-dot--red"></span> {{ redCount }}
        &nbsp;
        <span class="sd-dot sd-dot--amber"></span> {{ amberCount }}
        &nbsp;
        <span class="sd-dot sd-dot--green"></span> {{ greenCount }}
      </span>
    </div>

    <!-- ── DataURI warning ───────────────────────────────────────── -->
    <div class="alert alert-warning" *ngIf="!controller?.dataUri">
      <i class="fa fa-exclamation-triangle me-2"></i>
      DataURI is not configured in the INDICIUM DataBus for this controller.
    </div>

    <!-- ── Controller Activity ─────────────────────────────────── -->
    <div class="sd-section-title">Controller Activity (Last 14 Days)</div>

    <div class="sd-ctrl-loading" *ngIf="controllerDataLoading">
      <i class="fa fa-spinner fa-spin me-2"></i> Loading controller data&hellip;
    </div>

    <ng-container *ngIf="!controllerDataLoading && !controllerNoData">
      <div class="sd-ctrl-grid">

        <div class="sd-ctrl-card" [ngClass]="ctrlCurrentState === 'enabled' ? 'sd-ctrl-card--enabled' : ctrlCurrentState === 'disabled' ? 'sd-ctrl-card--disabled' : 'sd-ctrl-card--neutral'">
          <div class="sd-ctrl-card__label">Current State</div>
          <div class="sd-ctrl-card__value" [ngClass]="ctrlCurrentState === 'enabled' ? 'sd-ctrl-card__value--enabled' : ctrlCurrentState === 'disabled' ? 'sd-ctrl-card__value--disabled' : ''">
            {{ ctrlCurrentState === 'enabled' ? 'Enabled' : ctrlCurrentState === 'disabled' ? 'Disabled' : '--' }}
          </div>
          <div class="sd-ctrl-card__warning" *ngIf="controller?.currentIrrigationState?.value === true" title="Irrigation override expected state and actual state do not match.">
            Override Warning
          </div>
          <div class="sd-ctrl-card__sub" *ngIf="controller?.currentIrrigationState?.value === false">Irrigation Override</div>
        </div>

        <div class="sd-ctrl-card sd-irrigation-state" [ngClass]="ctrlIrrigationActive === true ? 'sd-irrigation-state--active' : 'sd-irrigation-state--inactive'">
          <div class="sd-irrigation-state__label">Irrigation Status</div>
          <div class="sd-irrigation-state__value" [title]="ctrlIrrigationActive">
            {{ ctrlIrrigationActive === true ? 'Irrigating' : ctrlIrrigationActive === false ? 'OFF' : 'Unavailable' }}
          </div>
          <div class="sd-irrigation-state__sub">Irrigation Status </div>
        </div>

        <div class="sd-ctrl-card sd-ctrl-card--neutral">
          <div class="sd-ctrl-card__label">Control Events</div>
          <div class="sd-ctrl-card__value">{{ ctrlEvents }}</div>
          <div class="sd-ctrl-card__sub">Times Irrigation Disabled</div>
        </div>

        <div class="sd-ctrl-card sd-ctrl-card--neutral">
          <div class="sd-ctrl-card__label">Irrigation Disabled</div>
          <div class="sd-ctrl-card__value">{{ ctrlDisabledDuration }}</div>
          <div class="sd-ctrl-card__sub">{{ ctrlDisabledPercent }} of window</div>
        </div>

        <div class="sd-ctrl-card sd-ctrl-card--neutral">
          <div class="sd-ctrl-card__label">Last Disabled</div>
          <div class="sd-ctrl-card__value sd-ctrl-card__value--sm">
            {{ ctrlLastDisabledAt ? (ctrlLastDisabledAt | date:'d MMM, HH:mm') : '--' }}
          </div>
          <div class="sd-ctrl-card__sub">Last 0 &rarr; 1 transition</div>
        </div>

        <div class="sd-ctrl-card sd-ctrl-card--neutral">
          <div class="sd-ctrl-card__label">Last Reported</div>
          <div class="sd-ctrl-card__value sd-ctrl-card__value--sm">
            {{ ctrlLastReportedAt ? (ctrlLastReportedAt | date:'d MMM, HH:mm') : '--' }}
          </div>
          <div class="sd-ctrl-card__sub">{{ ctrlLastReportedAt ? (ctrlLastReportedAt | relativeDate) : '--' }}</div>
        </div>

        <!--<div class="sd-ctrl-card sd-ctrl-card--neutral">
          <div class="sd-ctrl-card__label">Controller Details</div>
          <div class="sd-ctrl-card__value sd-ctrl-card__value--sm">
            {{ controller?.deviceEui || '--' }}
          </div>
          <div class="sd-ctrl-card__sub" [title]="controller?.dataUri">{{controller?.siteUri}}</div>
        </div>-->

      </div>

      <div class="sd-chart-card">
        <div class="sd-chart-card__title">Irrigation Override &mdash; 14-Day History</div>
        <highcharts-chart
          [Highcharts]="Highcharts"
          [constructorType]="chartConstructor"
          [options]="ctrlChartOptions"
          style="width:100%;height:150px;display:block;">
        </highcharts-chart>
        <div class="sd-chart-card__legend">
            <span class="sd-chart-legend sd-chart-legend--green"
              [title]="overrideDataName + ' | URI: ' + overrideDataUri">&#9644; Irrigation Enabled</span>
            <span class="sd-chart-legend sd-chart-legend--red"
              [title]="overrideDataName + ' | URI: ' + overrideDataUri">&#9644; Irrigation Disabled</span>
            <span class="sd-chart-legend" style="color: #0d6efd;"
              [title]="irrigationStateDataName + ' | URI: ' + irrigationStateDataUri">&#9472; Irrigation State</span>
        </div>
      </div>

      <div class="alert alert-warning mt-3" *ngIf="irrigationStateNoData">
        <i class="fa fa-exclamation-triangle me-2"></i>
        <strong>Irrigation State Not Connected</strong> — Actual irrigation state data is not available for this controller.
      </div>
    </ng-container>

    <div class="text-muted small p-2 mb-3" *ngIf="!controllerDataLoading && controllerNoData">
      No controller activity data available for this period.
    </div>

    <!-- ── Soil Sensors ────────────────────────────────────────── -->
    <div class="sd-section-title">Soil Sensors</div>
    <div class="sd-grid">
      <div class="sd-sensor-card" [ngClass]="'sd-sensor-card--' + sensor.status" *ngFor="let sensor of sensors" (click)="viewSensorTrend(sensor)">
        <div class="sd-sensor-card__header">
          <div>
            <div class="sd-sensor-card__name" [title]="sensor.deviceEui">{{ sensor.name }}</div>
            <div class="sd-sensor-card__sub">{{ sensor.subtitle }}</div>
          </div>
          <div class="sd-sensor-card__header-right">
            <span class="sd-badge" [ngClass]="'sd-badge--' + sensor.status">
              {{ sensor.status === 'alert' ? 'ALERT' : sensor.status === 'warning' ? 'WARNING' : 'NORMAL' }}
            </span>
            <div class="sd-sensor-card__reported" *ngIf="sensor.lastReportedAt">
              {{ sensor.lastReportedAt | relativeDate }}
            </div>
            <div class="sd-sensor-card__reported sd-sensor-card__reported--never" *ngIf="!sensor.lastReportedAt">
              No data received
            </div>
          </div>
        </div>
        <div class="sd-sensor-card__metrics">
          <div class="sd-metric">
            <span class="sd-metric__label">Moisture</span>
            <span class="sd-metric__val" [ngClass]="'sd-metric__val--' + sensor.moisture.status">{{ sensor.moisture.value }}{{ sensor.moisture.unit }}</span>
            <span class="sd-metric__sub">{{ sensor.moisture.statusLabel }}</span>
          </div>
          <div class="sd-metric">
            <span class="sd-metric__label">Temp</span>
            <span class="sd-metric__val" [ngClass]="sensor.temp.value === 'N/A' ? 'sd-metric__val--muted' : 'sd-metric__val--' + sensor.temp.status" title="Soil temperature ranges: green 10–35°C, amber 5–10°C or 35–40°C, red below 5°C or above 40°C.">{{ sensor.temp.value }}{{ sensor.temp.value !== 'N/A' ? sensor.temp.unit : '' }}</span>
            <span class="sd-metric__sub">{{ sensor.temp.statusLabel }}</span>
          </div>
          <div class="sd-metric">
            <span class="sd-metric__label">EC</span>
            <span class="sd-metric__val" [ngClass]="sensor.ec.value === 'N/A' ? 'sd-metric__val--muted' : 'sd-metric__val--' + sensor.ec.status" title="EC salinity ranges: green up to 2000 µS/cm, amber above 2000 µS/cm, red above 4000 µS/cm.">{{ sensor.ec.value }}{{ sensor.ec.value !== 'N/A' ? sensor.ec.unit : '' }}</span>
            <span class="sd-metric__sub">{{ sensor.ec.statusLabel }}</span>
          </div>
        </div>
        <div class="sd-sensor-card__alert" [ngClass]="'sd-sensor-card__alert--' + sensor.alertType" *ngIf="sensor.alertMessage">
          {{ sensor.alertMessage }}
        </div>
        <div class="sd-sensor-card__footer">View 14-day trend &#8594;</div>
      </div>
      <div class="text-muted p-3" *ngIf="sensors.length === 0">No soil sensors for this controller.</div>
    </div>

    <div class="sd-section-title">Weather Station</div>
    <div class="sd-weather-grid" *ngIf="weatherMetrics.length > 0">
       <div class="sd-weather-card" [ngClass]="'sd-weather-card--' + metric.status" *ngFor="let metric of weatherMetrics"
         (click)="viewWeatherTrend()" style="cursor:pointer">
        <div class="sd-weather-card__label">{{ metric.label }}</div>
        <div class="sd-weather-card__value" [ngClass]="'sd-weather-card__value--' + metric.status">
          {{ metric.value }}<span class="sd-weather-card__unit"> {{ metric.unit }}</span>
        </div>
        <div class="sd-weather-card__status" [ngClass]="'sd-weather-card__status--' + metric.status">
          <span class="sd-dot" [ngClass]="'sd-dot--' + metric.status"></span> {{ metric.statusLabel }}
        </div>
      </div>
    </div>
    <div class="text-muted p-3 mb-4" *ngIf="weatherMetrics.length === 0">No weather station data available.</div>

  </ng-container>

</div>